export const AdminListTenantAdminKey = "AdminListTenantAdminKey";
export const UserManagerUserListTenantAdminKey = "UserManagerUserListTenantAdminKey";
export const AlertListTenantAdminKey = "AlertListTenantAdminKey";
export const EmailListTenantAdminKey = "EmailListTenantAdminKey";
export const PhoneListTenantAdminKey = "PhoneListTenantAdminKey";
export const FileUploadTenantAdminKey = "FileUploadTenantAdminKey";
export const FileUploadsTenantAdminKey = "FileUploadsTenantAdminKey";
export const UserListTenantAdminKey = "UserListTenantAdminKey";

export const updateAdministratorListFilters = (filters) => {
  return {
    type: 'SET_ADMINISTRATOR_LIST_FILTERS',
    filters
  }
}

export const updateAlertListFilters = (filters) => {
  return {
    type: 'SET_ALERT_LIST_FILTERS',
    filters
  }
}

export const setSelectedTenantAdminType = (selectedTenantAdminType) => {
  return {
    type: 'SET_SELECTED_TENANT_ADMIN_TYPE',
    selectedTenantAdminType
  }
}